import { createSelector } from '@ngrx/store';

import { createSingleEntityStore } from '@core/ngrx-legacy';
import { TellentDevFlagsMap, TellentDevFlag } from '@core/tellent-types';

import { INITIAL_STATE } from './utils';

const { selectors, reducer, namespace, actions } = createSingleEntityStore<TellentDevFlagsMap>()(
  'TellentDevFlags',
  {
    initialState: INITIAL_STATE,
  },
);

const isEnabled = (props: { flag: TellentDevFlag }) =>
  createSelector(selectors.data, state => (state ? state[props.flag] : false));

const TellentDevFlagsSelectors = {
  ...selectors,
  isEnabled,
};

export {
  TellentDevFlagsSelectors,
  actions as TellentDevFlagsActions,
  namespace as TellentDevFlagsNamespace,
  reducer as TellentDevFlagsReducer,
};
